<div class="padding" style="min-width: 500px">
    <mat-progress-bar *ngIf="is_loading" mode="indeterminate"></mat-progress-bar>
    <ng-container *ngIf="!is_loading">
        <div style="padding-bottom: 16px;"><b>Captains</b></div>
        <div *ngFor="let captain of captains">
            {{captain.username}}
        </div>
    </ng-container>
</div>